import React from 'react'
import CompanySupport from '../components/ComapnySupport/CompanySupport'
import CommonBanner from "../components/Common Banner Component/HeroBanner"
import TestimonialForm from '../components/TestimonialForm/TestimonialForm'
import PartnerCompanies from '../components/PartnerCompanies/PartnerCompanies'
import AboutIcons from '../components/AboutIcons/AboutIcons'
import AboutIdeas from '../components/AboutIdeas/AboutIdeas'
import AboutHistory from '../components/AboutHistory/AboutHistory'
import { Helmet } from 'react-helmet'

function about() {
  return (
    <>
     <Helmet>
          <link rel="canonical" href="https://www.lotusaccounting.ca/about" />
           <title>
          About Lotus Accounting | Trusted CPA Firm in Ontario
        </title>
        <meta
          name='description'
          content=' Learn about Lotus Accounting, a CPA-led firm helping Ontario businesses with bookkeeping, tax planning, payroll, and financial advisory since 2015.'>
        </meta>
        </Helmet>
        <CommonBanner
          subHeading="ABOUT US"
          Heading= "Why Choose Lotus Accounting?"
          Paragraph="Since 2015, Lotus Accounting has helped Ontario’s small and mid-sized businesses thrive with CPA-led, cloud-based accounting. Our 100 % Canadian team pairs strategic insight with rigorous compliance, offering industry-specific solutions that scale as you grow. Expect meticulous bookkeeping, proactive tax planning, transparent flat-rate pricing, and quick, personable support—everything you need from a trusted financial partner in one place."
          btnText=""
          bgImg="/images/creative/about-bg.jpg"
          btn={false}
          showPartners={true}
        />
        <PartnerCompanies/>
        <AboutIdeas/>
        <CompanySupport/>
        <AboutHistory/>
        <AboutIcons/>
        <TestimonialForm PartnerCompaniesSection={false}/>
    </>
  )
}

export default about